import CardStack from '@shared/components/core/card/CardStack';
import { useTranslation } from 'react-i18next';
import OrgLinks from '../OrgLinks';

interface IOrgMemberCardProps {
    orgId: string;
}

export default function OrgMemberCard({ orgId }: IOrgMemberCardProps) {
    const { t } = useTranslation();

    if (!orgId) return null;
    return (
        <CardStack
            name="orgMembers"
            title={t('common:organization.member.viewAll.title')}
            description={t('common:organization.member.viewAll.description')}>
            <OrgLinks organizationId={orgId} variant={'orgMembers'} />
        </CardStack>
    );
}
